import gsap from 'gsap';

const openSub = menu => {
    const items = menu.html();
    addItems(items);
}

const addItems = items => {
    $('.sub-menu').html(items);
    const open = gsap.timeline({
        paused: true,
    });

    open
        .staggerTo('.sub-menu .nav-item', 0.5, {
            x: 0,
            opacity: 1,
            ease: "easeInOut",
        }, 0.1);

    open.play();
}

const removeItems = () => {
    const close = gsap.timeline({
        paused: true,
    });

    close
        .staggerTo('.sub-menu .nav-item', 0.3, {
            opacity: 0,
            ease: "easeInOut",
        }, 0.05);

    close.play();

    setTimeout(() => {
        $('.sub-menu').html('');
    }, 700);
}

const toggleMenu = el => {
    const menu = el.next();

    $('.dropdown-menu-toggler').not(el).removeClass('active');
    if(el.hasClass('active')) {
        removeItems();
    } else {
        openSub(menu);
    }

    el.toggleClass('active');
}

const toggleMobileMenu = el => {
    $('.dropdown-menu-toggler.active').not(el).each( function() {
        $(this).toggleClass('active');
        $(this).next().slideToggle();
    });
    el.toggleClass('active');
    el.next().slideToggle();
}

$(document).on('click', '.dropdown-menu-toggler', function() {
    if (screen.width > 993) {
        toggleMenu($(this));
    } else {
        toggleMobileMenu($(this));
    }
})

$('.nav-link.has-dropdown').on('click', function() {
    if($(this).attr('href') == '#') {
        if (screen.width > 993) {
            toggleMenu($(this).next());
        } else {
            toggleMobileMenu($(this).next());
        }
    }
})
